import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { partANeedsModal } from '@/hooks/useOnboardingHub';
import { partARedirectPath } from './partASignOut';

/**
 * Route guard: a company_admin who has not completed "Set up your company" is
 * sent back to /dashboard, where the Part A modal is open. Sign-out stays open.
 */
export function RequirePartA({ user, children }) {
  const location = useLocation();
  const redirectTo = partARedirectPath(partANeedsModal(user), location.pathname);
  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}

export default RequirePartA;
